import SampleAnalytesModel from "@/models/lab/SampleAnalytesModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class SampleAnalytesCollection extends LabServiceCollection {
  model() {
    return SampleAnalytesModel;
  }
}
